import { UserIcon, XMarkIcon } from "@heroicons/react/20/solid";
import React, { useEffect } from "react";
import { connect } from 'react-redux';
import { Actions as INTEGRATION_ACTIONS } from "../../store/actions/integrationActions";
import { Actions as AUTHENTICATION_ACTIONS } from "../../store/actions/authenticationActions";
import { Link } from "react-router-dom";
import NoItemsRow from "../common/NoItemsRow";

const UserConnectedOrgsModal = ({
    userIntegrationID,
    getLinkedOrgIntegrations,
    closeModal,
    setCompany,
    modalOpen,
    integrationName,
    integrationType,
    disconnectLinkedOrg,
    userConnectedOrgs,
    companyList,
}) => {

    useEffect(() => {
        if (!modalOpen) return
        getLinkedOrgIntegrations(userIntegrationID)

    }, [modalOpen, userIntegrationID])

    if (!modalOpen) return null

    return (
        <div className="modal" tabIndex="-1" role="dialog" aria-hidden="true" style={{ display: "block", background: "rgba(0,0,0,0.4)" }}>
            <div className="modal-dialog" style={{ width: "70%", marginTop: "15%" }}>
                <div className="modal-content">
                    <div className="block block-themed block-transparent remove-margin-b" style={{ padding: 0 }}>
                        <div className="block-header bg-primary-dark" style={{ padding: 20 }}>
                            <ul className="block-options">
                                <li>
                                    <button type="button" onClick={closeModal}><XMarkIcon className="h-6 w-6 mr-3 text-white" /></button>
                                </li>
                            </ul>
                            <h3 className="block-title">Connected Organisations</h3>
                        </div>

                        <div className="modal-content" style={{ padding: "20px 20px 1px" }}>
                            <h4>{integrationType} Integration: {integrationName}</h4>
                            <p className="help-block" style={{ marginBottom: 0 }}>
                                Below is a list of organisations that are connected and linked to your personal connection to {integrationName}.
                                <br />
                                Any data that is synced from organisations/accounts that you have access to on {integrationName} will be synced to these organisations using this personal connection.
                                You can disconnect any of these organisations at any time.
                            </p>
                        </div>
                        <div className="clearfix" />
                        {userConnectedOrgs?.length > 0 ? <>
                            <div className="block-content" style={{ padding: "0px 20px 1px" }}>
                                <div
                                    className="form-section"
                                    style={{ display: "grid", gridGap: "1.5rem", grid: "1.5rem", gridTemplateColumns: "repeat(3, minmax(0, 1fr))", padding: '1rem', borderBottom: 'solid rgb(244,244,244) 4px' }}>
                                    <div style={{ gridColumn: "span 1 / span 3", textAlign: 'center', opacity: '0.75' }}>
                                        <h5>Organisation</h5>
                                    </div>
                                    <div style={{ gridColumn: "span 1 / span 3", textAlign: 'center', opacity: '0.75' }}>
                                        <h5>Connected To</h5>
                                    </div>
                                    <div style={{ gridColumn: "span 1 / span 3", textAlign: 'center', opacity: '0.75' }}>
                                        <h5></h5>
                                    </div>
                                </div>

                                {userConnectedOrgs?.map((integration, index) => {
                                    const isLast = userConnectedOrgs.length === index
                                    return (<>
                                        <div
                                            key={`${integration.id}`}
                                            className="form-section"
                                            style={{
                                                display: "grid",
                                                gridGap: "1.5rem",
                                                grid: "1.5rem",
                                                gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
                                                padding: '1rem',
                                                borderBottom: isLast ? undefined : 'solid rgb(244,244,244) 4px'
                                            }}
                                        >
                                            <div style={{ gridColumn: "span 1 / span 3", textAlign: 'center' }}>
                                                <div onClick={(e) => {
                                                    e.preventDefault()
                                                    e.stopPropagation()
                                                    setCompany(integration.org)
                                                }}
                                                    style={{ cursor: 'pointer' }}>
                                                    {companyList?.find(({ id }) => id === integration.org)?.name}
                                                </div>
                                            </div>
                                            <div style={{ gridColumn: "span 1 / span 3", textAlign: 'center' }}>
                                                {integration.companyName || 'Not Linked'}
                                            </div>
                                            <div style={{ gridColumn: "span 1 / span 3", textAlign: 'center' }}>
                                                {integration.companyName ? <>
                                                    <button
                                                        type='button'
                                                        onClick={() => setCompany(integration.org)}
                                                        className="btn btn-xs btn-primary"
                                                    >
                                                        Switch Organisation
                                                    </button>
                                                </> : <>
                                                    <button
                                                        className="btn btn-xs btn-danger"
                                                        type='button'
                                                        onClick={() => {
                                                            closeModal()
                                                            disconnectLinkedOrg(integration.id)
                                                        }}
                                                    >
                                                        Disconnect
                                                    </button>
                                                </>}
                                            </div>
                                        </div>
                                    </>)
                                })}
                            </div>
                        </> : <div style={{ paddingTop: '2rem', paddingBottom: '2rem' }}>
                            <NoItemsRow div={true} name={`Connections`} />
                        </div>}
                        <div className="clearfix" />
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state, ownProps) => {

    const { id, name, type } = state.my.userConnectedIntegration || {}
    const { userConnectedOrgs } = state.my || {}

    return {
        modalOpen: !!id,
        userIntegrationID: id,
        userConnectedOrgs,
        integrationName: name,
        integrationType: type,
        companyList: state.organisations
    };
};

const mapDispatchToProps = dispatch => ({
    closeModal: () => dispatch(INTEGRATION_ACTIONS.openUserConnectedOrgsModal()),
    disconnectLinkedOrg: (id) => dispatch(INTEGRATION_ACTIONS.disconnectLinkedOrg(id)),
    getLinkedOrgIntegrations: (id) => dispatch(INTEGRATION_ACTIONS.getLinkedOrgIntegrations(id)),
    setCompany: (org) => dispatch(AUTHENTICATION_ACTIONS.switchCompany(org)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UserConnectedOrgsModal)